import BaseElement from './BaseElement'
import { AccountHeader } from '../components/AccountHeader'

export default class AccountHeaderElement extends BaseElement {
  renderElement () {
    this.rootElement.render(<AccountHeader />)
  }
}
